import React from 'react';
import styled from 'styled-components';

import Box from '@ui/box/Box.tsx';
import Text from '@ui/text/Text.tsx';

import { useCSSColors } from '../../../../../src/hooks/useCSSColors.ts';

const StyledSearchResultsIndicator = styled(Box)`
  flex: 0 0 auto;
`;

const SearchResultsIndicator = ({ ref, ...props }) => {
  const colors = useCSSColors();
  const { resultsNumber, ...omittedProps } = props;

  return (
    <StyledSearchResultsIndicator
      aria-hidden={true}
      data-testid="SearchResultsIndicator"
      ref={ref}
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="24px"
      height="24px"
      borderRadius="100%"
      bg={colors.mapNavSearchResults}
      color={colors.mapNavSearchResultsText}
      {...omittedProps}
    >
      {typeof resultsNumber !== 'undefined' && <Text fontSize="sm">{resultsNumber > 99 ? '99+' : resultsNumber}</Text>}
    </StyledSearchResultsIndicator>
  );
};

SearchResultsIndicator.displayName = 'SearchResultsIndicator';

export default SearchResultsIndicator;
